import React, { useContext } from 'react';
import { FormattedMessage } from 'react-intl';
import { useTheme } from 'ThemeContext';

import IMAGE_PERSON from 'assets/Images/lucky_number_person.png';
import IMAGE_BG from 'assets/Images/lucky_number_bg.png';
import IMAGE_BG_ANIMALS from 'assets/Images/lucky_number_bg_animals.png';
import IMAGE_ANIMALS from 'assets/Images/lucky_number_animals.png';

import {
  Item,
  BackgroundImagebox,
  BackgroundImage,
  Imagebox,
  Image,
  Content,
  Title,
  Text
} from './WidgetLuckyNumber.style';
import { AppSettingsContext } from 'AppSettingsContext';

function WidgetLuckyNumber({ data = {} }) {
  const [appSettings] = useContext(AppSettingsContext);
  const theme = useTheme();
  return (
    <Item theme={theme.widgetLuckyNumber.item}>
      <BackgroundImagebox>
        <BackgroundImage
          src={
            data.backgroundImage || appSettings.theme === 4
              ? IMAGE_BG_ANIMALS
              : IMAGE_BG
          }
          loading='lazy'
          alt=''
        />
      </BackgroundImagebox>
      <Imagebox theme={theme.widgetLuckyNumber.imageBox}>
        <Image
          src={
            data.image || appSettings.theme === 4 ? IMAGE_ANIMALS : IMAGE_PERSON
          }
          loading='lazy'
          alt=''
        />
      </Imagebox>

      <Content theme={theme.widgetLuckyNumber.content}>
        <Title theme={theme.widgetLuckyNumber.title}>
          {data.title ? (
            data.title
          ) : (
            <FormattedMessage id='WIDGET_LUCKY_NUMBER.LUCKY_NUMBER' />
          )}
        </Title>
        <Text theme={theme.widgetLuckyNumber.text}>{data.number}</Text>
      </Content>
    </Item>
  );
}

export default WidgetLuckyNumber;
